import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { BaseURL } from "../../../constants/enum/baseURL.emum";
import reportService from "../../../services/report.service";
import scheduleService from "../../../services/schedule.service";
import Loadding from "../../common/loadding";
import ShowDoc from "../../common/showDoc";
import BtnSendDoc3 from "../../send/doc3/btnSendDoc3";
import BtnDeleteDoc3 from "./btnDeleteDoc3";
import GroupCheck from "./groupCheck";

const ListItemDoc3 = (props: any) => {
  const me = useSelector((state: any) => state.me);
  const { data } = props;
  const { course } = data;
  const [doc3, setDoc3] = useState<any>([]);
  const [status, setStatus] = useState<any>(false);
  const [btnDoc5, setBtnDoc5] = useState(false);
  // console.log(course);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  useEffect(() => {
    (async () => {
      //ไปเช็คที่ตาราง doc3 ว่ามี sche / course นี้ยัง
      await reportService.checkSend(data.schedule, course.id).then((res) => {
        // setteacher(res.data.teacher);
        // console.log(res.data);
        setDoc3(res.data);
        setStatus(true);
      });
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await scheduleService.getById(Number(data.schedule)).then((res) => {
        // const DateDoc3 = new Date(res.data.doc3);
        const DateDoc5 = new Date(res.data.doc5).setHours(0, 0, 0, 0);
        const toDay = new Date().setHours(0, 0, 0, 0);
        // console.log("to Day", toDay);
        // console.log("Date For Doc5", toDay);
        // console.log(toDay >= DateDoc5);

        if (toDay >= DateDoc5) {
          setBtnDoc5(true);
        }

        // console.log(toDay <= DateDoc3);
      });
    })();
  }, []);

  if (!status) return <Loadding />;

  // {!sendList && (
  //       <BtnSendDoc3 schedule={schedule} curri={curriInfo} course={course} />
  //     )}

  return (
    <>
      {doc3 && (
        //กรณีที่มี
        <tr key={`course.id`}>
          <td>{course.courseCode}</td>
          <td>{course.name}</td>
          <td>{course.cradit}</td>
          <td>{data.responsible}</td>
          <td>{data.group}</td>
          <td>
            {doc3.doc5.split(",").map((x: string) => {
              return (
                <GroupCheck
                  key={x}
                  group={x}
                  doc3Id={doc3.id}
                  type={data.schedule.type === "tqf" ? "มคอ." : "อชว."}
                />
              );
            })}
          </td>

          <td>
            <ShowDoc
              btnName={`เอกสาร ${
                data.schedule.type === "tqf" ? "มคอ." : "อชว."
              }3`}
              url={`${BaseURL.BASE_URL}/upload/doc3/${doc3.pathFile}`}
            />{" "}
            <Link
              to={{
                pathname: `/report/${data.schedule.id}/${course.owner.id}/${doc3.id}`,
              }}
              className="btn btn-sm btn-warning"
            >
              ดูรายงานการส่ง {data.schedule.type === "tqf" ? "มคอ." : "อชว."}5
            </Link>{" "}
            {
              btnDoc5 && `ทดสอบ`
              // <BtnSendDoc5
              //   schedule={schedule}
              //   curri={curri}
              //   course={course}
              //   teacher={teacher}
              //   doc5={doc5}
              //   doc3Id={doc3Id}
              // />
            }
            {me.role === "Admin" && (
              <BtnDeleteDoc3
                type={data.schedule.type === "tqf" ? "มคอ." : "อชว."}
                id={doc3.id}
              />
            )}
          </td>
        </tr>
      )}
      {!doc3 && (
        <tr key={`course.id`}>
          <td>{course.courseCode}</td>
          <td>{course.name}</td>
          <td>{course.cradit}</td>
          <td>{data.responsible}</td>
          <td>{data.group}</td>
          <td>{doc3.doc5}</td>

          <td>
            <BtnSendDoc3
              schedule={data.schedule.id}
              curri={course.owner}
              course={{ course: { ...course } }}
              responsible={data.responsible}
              group={data.group}
            />
          </td>
        </tr>
      )}
    </>
  );
};

export default ListItemDoc3;
